import { render } from "./Cross.vue?vue&type=template&id=9a5baa66"
const script = {}
script.render = render

export default script